import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cmn-notification-bar',
  templateUrl: './notification-bar.component.html',
  styleUrls: ['./notification-bar.component.scss']
})
export class NotificationBarComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
